const key = (userId: string) => `rp.tenant.${userId}`

export const readStoredTenant = (storage: Pick<Storage, 'getItem'>, userId: string): string | null => {
  try {
    return storage.getItem(key(userId))
  } catch {
    return null
  }
}

export const storeTenant = (storage: Pick<Storage, 'setItem'>, userId: string, tenantId: string): void => {
  try {
    storage.setItem(key(userId), tenantId)
  } catch {
    return
  }
}
